import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Color from '../../../enums/color';
import { KPMGMainLogoWhiteIcon } from '../../../assets/icons';
const StyledNavigationFooter = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 100%;
  padding: 0 12px 24px 32px;
  color: ${Color.White};

  > span {
    font-size: 10px;
    color: ${Color.White};
    opacity: 0.4;
  }
`;
const ProductOwner = styled.div `
  display: flex;
  align-items: center;

  > span {
    margin-right: 12px;
    font-size: 14px;
  }
`;
const StyledKPMGMainLogoIcon = styled(KPMGMainLogoWhiteIcon) `
  width: 48px;
  height: 48px;
`;
const NavigationFooter = () => {
    const { t: translate } = useTranslation();
    return (<StyledNavigationFooter>
      <ProductOwner>
        <span>{translate('SIDER.MESSAGE.PRODUCT')}</span>
        <StyledKPMGMainLogoIcon />
      </ProductOwner>
      <span>{translate('SIDER.MESSAGE.COPYRIGHT')}</span>
      <span>{translate('SIDER.MESSAGE.VERSION')}</span>
    </StyledNavigationFooter>);
};
export default NavigationFooter;
